//
//
//
//
//
//
//

export default {
  props: {
    bgColor: {
      type: String,
      default: null
    }
  }
}
